import { IBAN, BANK_NAME_AR, USERNAME, BANK_NAME_EN, SWIFT } from "./constant";

// material ui components
import Box from "@mui/material/Box";

// styles
import styles from "./styles.module.css";

const BankInfo = (props: any) => {
  const { data } = props;
  return (
    <div>
      <div className={styles.bankInfoSection}>
        <div>{USERNAME}</div>
        <div>{data?.beneficiaryName}</div>
      </div>

      <div className={styles.bankInfoSection}>
        <div>{IBAN}</div>
        <div>{data?.iban}</div>
      </div>

      <div className={styles.bankInfoSection}>
        <div>{BANK_NAME_AR}</div>
        <div>{data?.bank?.arabicName}</div>
      </div>
      <div className={styles.bankInfoSection}>
        <div>{BANK_NAME_EN}</div>
        <div>{data?.bank?.englishName}</div>
      </div>

      <div className={styles.bankInfoSection}>
        <div>{SWIFT}</div>
        <div>{data?.bank?.swiftCode}</div>
      </div>
    </div>
  );
};

export default BankInfo;
